import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { PublicRoutes, QueryParamKeys, useLogout } from "src/common";
import { Loading } from "src/components";

function LogoutComponent() {
  const [search_params] = useSearchParams();
  const [redirect_url, setRedirectURL] = useState<string>(`/${PublicRoutes.choose_account_route}`);
  const { logged_out, handleStateLogout } = useLogout();

  useEffect(() => {
    handleStateLogout();
    // NOTE: If redirect comes in as a querystring handle custom redirect
    const query_redirect_url = search_params.get(QueryParamKeys.REDIRECT_URL_QUERY_KEY);
    setRedirectURL(!!query_redirect_url ? query_redirect_url : `/${PublicRoutes.choose_account_route}`);
  }, []);

  useEffect(() => {
    if (logged_out) {
      window.location.replace(redirect_url);
    }
  }, [logged_out]);

  return <Loading />;
}

export default React.memo(LogoutComponent);